import * as React from 'react';

import { useSelector } from 'react-redux';
import { getPagination } from '../../selectors/pagination';
import { getTitle } from './utils/getTitle';
import { Title } from '../../components/Title/Title';
import { useDeviceType } from '@cian/ui-kit';

export const TitleContainer = () => {
  const { total } = useSelector(getPagination);
  const counter: string = getTitle(total);
  const device = useDeviceType();

  return <Title counter={counter} withProjectsLink={device === 'desktop'} />;
};
